
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import { Room, RoomSpace } from '@/utils/models';

@Component({ components: { Popup } })
export default class RemoveRoomOrSpacePopup extends Vue {
  @Prop() roomOrSpace!: Room | RoomSpace;
  @Prop() title!: 'ルーム' | 'スペース';
  @Prop() isVisible!: boolean;
  @Prop() room!: Room;

  onConfirm(): void {
    this.removeRoomOrSpace(this.roomOrSpace);
  }

  hidePopup(): void {
    this.$emit('close');
  }
  @Emit()
  removeRoomOrSpace(target: Room | RoomSpace) {}
}
